import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Target, Heart, Users, Award, BookOpen, Lightbulb, TrendingUp } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: <Award className="h-8 w-8" />,
      title: "Excelencia Académica",
      description: "Promovemos los más altos estándares de calidad en la educación superior digital."
    },
    {
      icon: <Target className="h-8 w-8" />,
      title: "Alcance Global",
      description: "Conectamos educadores de todo el mundo bajo una visión compartida de innovación."
    },
    {
      icon: <Lightbulb className="h-8 w-8" />,
      title: "Innovación Educativa",
      description: "Fomentamos el uso creativo de tecnologías para transformar el aprendizaje."
    },
    {
      icon: <Heart className="h-8 w-8" />,
      title: "Compromiso Social",
      description: "Creemos en la educación como motor de desarrollo social y bienestar comunitario."
    }
  ];

  const team = [
    {
      name: "Dr. Donato Vallín",
      position: "Director General",
      expertise: "Liderazgo Institucional, Estrategia Global",
      phone: "+52-317-38-23-08, +52-317-38-5-12-03",
      email: "dvallin@certification-grana.org",
      image: "https://granacertification.org/wp-content/uploads/2022/06/Direccion.png"
    },
    {
      name: "Dr. Alex Lightman",
      position: "Director de I+D+I",
      expertise: "Investigación, Desarrollo e Innovación",
      phone: "+1-415-857-5247",
      email: "dvallin@certification-grana.org",
      company: "Presidente de GINET LLC",
      location: "Albuquerque, NM",
      image: "https://granacertification.org/wp-content/uploads/2022/06/IMG9.png"
    },
    {
      name: "Dr. Ramiro Jordan",
      position: "Director Académico",
      expertise: "Programas Internacionales, ISTEC",
      phone: "+1 (505) 277-2412, +1 (505) 277-1439",
      email: "rjordan@ece.unm.edu",
      company: "Associate Dean of Engineering, University of New Mexico",
      location: "Albuquerque, NM",
      image: "https://granacertification.org/wp-content/uploads/2022/06/JordanA.png"
    },
    {
      name: "Dr. Francisco Santillán Campos",
      position: "Director de Calidad",
      expertise: "Aseguramiento de Calidad Educativa",
      phone: "(888) 536-5207 x705",
      email: "santillancampos@yahoo.com.mx",
      company: "Centro de Estudios e Investigación para el Desarrollo Docente",
      image: "https://granacertification.org/wp-content/uploads/2022/06/IMG6.png"
    },
    {
      name: "Dra. María Guadalupe Blunes",
      position: "Directora de Evaluación",
      expertise: "Evaluación Académica y Competencias",
      phone: "+52 (317) 107 4 8 81",
      email: "maria.rodriguezbl@uanl.edu.mx",
      company: "Universidad Autónoma de Nuevo León",
      location: "San Nicolás de los Garza, NL, México",
      image: "https://granacertification.org/wp-content/uploads/2022/06/IMG8.png"
    },
    {
      name: "Ing. Camilo Cervantes S.",
      position: "Director de Tecnologías",
      expertise: "Tecnologías Educativas, Plataformas Digitales",
      phone: "57(4)7927855",
      email: "cacesa8931@gmail.com",
      company: "Universidad de Córdoba",
      location: "Montería, Córdoba, Colombia",
      image: "https://granacertification.org/wp-content/uploads/2022/06/CamiloCervantes.png"
    },
    {
      name: "Dr. Kamil Agi",
      position: "Director de Proyectos Internacionales",
      expertise: "Desarrollo de Proyectos Globales",
      phone: "(888) 536-5207 x705",
      email: "rjordan@ece.unm.edu",
      company: "K&A Wireless, LLC",
      location: "Albuquerque, NM",
      image: "https://granacertification.org/wp-content/uploads/2022/06/IMG10.png"
    },
    {
      name: "Dr. Francisco Bernabé Ramos",
      position: "Director Administrativo",
      expertise: "Administración y Desarrollo Sustentable",
      phone: "+52 (317) 10 74 8 81",
      email: "francisco.bernabe19@hotmail.com",
      company: "Instituto de Desarrollo Económico Administrativo Sustentable",
      image: "https://granacertification.org/wp-content/uploads/2022/06/IMG7.png"
    },
    {
      name: "Mtra. Olga Ramírez",
      position: "Directora de Vínculo Internacional",
      expertise: "Relaciones Internacionales, Vinculación",
      phone: "+52 (317) 10 74 8 81",
      email: "olgar@certification-grana.org",
      image: "https://granacertification.org/wp-content/uploads/2022/06/OlgaRmz.png"
    },
    {
      name: "Dr. Prince Panezi",
      position: "Coordinador de Relaciones en África",
      expertise: "Desarrollo Educativo en África",
      phone: "+52-317-38-23-08, +52-317-38-5-12-03",
      email: "panezipouweedeou@gmail.com",
      image: "https://granacertification.org/wp-content/uploads/2022/06/CoordAfrica.png"
    },
    {
      name: "Dr. Carl Flemming",
      position: "Coordinador de Relaciones en Alemania",
      expertise: "Relaciones Académicas Europeas",
      phone: "57(4)7927855",
      email: "cflemm@gmail.com",
      image: "https://granacertification.org/wp-content/uploads/2022/06/CoordAlemania.png"
    },
    {
      name: "Dr. Gerardo Espinosa",
      position: "Coordinador de Relaciones en México",
      expertise: "Vinculación Nacional, Desarrollo Regional",
      phone: "+52-317-38-23-08, +52-317-38-5-12-03",
      email: "dvallin@certification-grana.org",
      image: "https://granacertification.org/wp-content/uploads/2022/06/GerardoE.png"
    }
  ];

  const achievements = [
    { number: "2500+", label: "Docentes Certificados", description: "En los últimos 3 años" },
    { number: "25", label: "Países Participantes", description: "Presencia internacional" },
    { number: "150", label: "Instituciones Aliadas", description: "Universidades asociadas" },
    { number: "98%", label: "Índice de Satisfacción", description: "Docentes certificados" }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative min-h-[500px] flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80"
            alt="Equipo colaborativo trabajando"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-gray-50/65 to-white/75"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold mb-6 text-gray-900">
                Acerca de <span className="text-orange-600">GRANA</span>
              </h1>
              <p className="text-xl text-gray-700 mb-8 leading-relaxed">
                Generation of Resources for Accreditation in Nations of the America
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                Somos una organización pionera dedicada a establecer y mantener los más altos
                estándares de calidad en la educación superior digital, conectando educadores
                de América y el mundo bajo una visión compartida de excelencia e innovación.
              </p>
            </div>
            <div className="flex justify-center">
              <div className="bg-white rounded-full shadow-lg p-4 flex items-center justify-center border-4 border-orange-200 hover:scale-105 transition-transform duration-300">
                <img src="https://granacertification.org/wp-content/uploads/2022/07/logo-header.jpg" alt="Logo GRANA" className="h-28 w-28 object-contain rounded-full" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div className="bg-white p-8 rounded-lg shadow-md border-l-4 border-amber-600">
              <div className="flex items-center mb-6">
                <Target className="h-8 w-8 text-amber-600 mr-3" />
                <h2 className="text-3xl font-bold text-gray-800">Misión</h2>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed">
                Impulsar la calidad, pertinencia e innovación educativa mediante procesos de
                evaluación, acreditación y certificación internacional que fortalezcan las
                competencias docentes en entornos digitales y promuevan la transformación
                educativa en América y el mundo.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-md border-l-4 border-red-600">
              <div className="flex items-center mb-6">
                <Target className="h-8 w-8 text-red-600 mr-3" />
                <h2 className="text-3xl font-bold text-gray-800">Visión</h2>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed">
                Ser el referente global en la certificación académica para docentes de educación
                superior, garantizando que los educadores estén preparados para los desafíos
                de la educación digital y contribuyan efectivamente a la transformación social
                a través de la excelencia educativa.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">
              Nuestros Valores
            </h2>
            <div className="w-24 h-1 bg-amber-600 mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center group">
                <div className="bg-red-900 text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-amber-600 transition-colors duration-300">
                  {value.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3">
                  {value.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Achievements */}
      <section className="py-16 bg-red-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-6">
              Nuestros Logros
            </h2>
            <p className="text-xl text-red-100 max-w-2xl mx-auto">
              Tres años transformando la educación superior digital
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {achievements.map((achievement, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl lg:text-5xl font-bold text-amber-300 mb-2">
                  {achievement.number}
                </div>
                <div className="text-lg font-semibold text-white mb-1">
                  {achievement.label}
                </div>
                <div className="text-red-200 text-sm">
                  {achievement.description}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">
              Equipo Directivo
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Hemos desarrollado grandes vínculos con personas excepcionales.
              Conoce a nuestro Equipo Directivo internacional comprometido con la excelencia educativa.
            </p>
            <div className="w-24 h-1 bg-orange-600 mx-auto mt-6"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {team.map((member, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden group hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                {/* Imagen redonda centrada y más pequeña */}
                <div className="flex justify-center pt-6 pb-4">
                  <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-orange-100 group-hover:border-orange-300 transition-colors duration-300">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                      onError={(e) => {
                        e.target.src = "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&h=300&fit=crop&crop=face";
                      }}
                    />
                  </div>
                </div>
                <div className="p-6 pt-2">
                  <h3 className="text-lg font-bold text-gray-800 mb-2 leading-tight text-center">
                    {member.name}
                  </h3>
                  <p className="text-orange-600 font-semibold mb-2 text-sm text-center">
                    {member.position}
                  </p>
                  <p className="text-gray-600 text-xs mb-3 leading-relaxed text-center">
                    {member.expertise}
                  </p>

                  {member.company && (
                    <p className="text-gray-500 text-xs mb-2 font-medium text-center">
                      {member.company}
                    </p>
                  )}

                  {member.location && (
                    <p className="text-gray-400 text-xs mb-3 text-center">
                      📍 {member.location}
                    </p>
                  )}

                  <div className="space-y-1">
                    {member.email && (
                      <a
                        href={`mailto:${member.email}`}
                        className="block text-xs text-red-700 hover:text-red-900 transition-colors truncate text-center"
                      >
                        ✉️ {member.email}
                      </a>
                    )}
                    {member.phone && (
                      <p className="text-xs text-gray-500 text-center">
                        📞 {member.phone}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Additional Info */}
          <div className="mt-12 bg-gradient-to-r from-orange-50 to-red-50 rounded-2xl p-8 border border-orange-100">
            <div className="text-center">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                Presencia Internacional
              </h3>
              <p className="text-gray-700 mb-6 max-w-3xl mx-auto">
                Nuestro equipo directivo representa la diversidad y alcance global de GRANA,
                con presencia en América, Europa y África, trabajando juntos para transformar
                la educación superior digital a nivel mundial.
              </p>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-2xl mx-auto">
                <div className="text-center">
                  <div className="text-2xl font-bold text-orange-600">🇺🇸</div>
                  <p className="text-sm text-gray-600 mt-1">Estados Unidos</p>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-orange-600">🇲🇽</div>
                  <p className="text-sm text-gray-600 mt-1">México</p>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-orange-600">🇨🇴</div>
                  <p className="text-sm text-gray-600 mt-1">Colombia</p>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-orange-600">🌍</div>
                  <p className="text-sm text-gray-600 mt-1">África & Europa</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Global Reach */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">
                Alcance Global
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                GRANA trabaja con instituciones, programas y profesionales de la educación
                superior en América y el mundo, fortaleciendo una comunidad de práctica con
                estándares comparables internacionalmente.
              </p>

              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <Users className="h-5 w-5 text-red-600" />
                  <span className="text-gray-700">Red de más de 150 instituciones aliadas</span>
                </div>
                <div className="flex items-center space-x-3">
                  <BookOpen className="h-5 w-5 text-red-600" />
                  <span className="text-gray-700">Programas reconocidos en 25 países</span>
                </div>
                <div className="flex items-center space-x-3">
                  <TrendingUp className="h-5 w-5 text-red-600" />
                  <span className="text-gray-700">Crecimiento del 300% en los últimos 3 años</span>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-red-900 to-red-700 text-white p-8 rounded-lg">
              <h3 className="text-2xl font-bold mb-6 text-amber-300">
                Impacto de la Certificación
              </h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-amber-300 rounded-full mt-2"></div>
                  <p className="text-red-100">
                    <strong>Reconocimiento internacional</strong> de competencias profesionales
                  </p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-amber-300 rounded-full mt-2"></div>
                  <p className="text-red-100">
                    <strong>Mejora del perfil académico</strong> y oportunidades de movilidad
                  </p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-amber-300 rounded-full mt-2"></div>
                  <p className="text-red-100">
                    <strong>Pertinencia de prácticas educativas</strong> en entornos digitales
                  </p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-amber-300 rounded-full mt-2"></div>
                  <p className="text-red-100">
                    <strong>Integración en red global</strong> de educadores certificados
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;